import { RulerSquareCompassIcon } from './RulerSquareCompassIcon';

/**
 * author: Michael Richins
 * id 2E24CF4F-2EC9-46C2-ABB9-341869D562EE
 * name ruler-square-compass
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ruler-square-compass.svg
 * tags
 * - Hardware / Tools 
 */
export const MasonicIcon = RulerSquareCompassIcon;
export default MasonicIcon